import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SvgIcon from '../icons/SvgIcon';

const DropDownItem = ({
    onSelect = f => f,
    className,
    disabled,
    selected,
    children,
    value,
    title,
    icon,
}) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (disabled || selected) return;

        onSelect && onSelect(e);
    };

    return (
        <li
            className={classNames('DropDownItem', className, { selected, disabled })}
            id={`option_${value}`}
            onClick={handleClick}
            title={title}
        >
            {icon ? <SvgIcon icon={icon} className="DropDownItem__icon" /> : ''}
            {children}
        </li>
    );
};

DropDownItem.propTypes = {
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    title: PropTypes.string,
    icon: PropTypes.string,
};

export default DropDownItem;
